import "reflect-metadata";
import Vue, { CreateElement } from "vue";
import container from "@/plugins/services";
import "@/plugins/env";
import { OrugaConfig } from "@/plugins/oruga";
import BibliotecaCompact from "./BibliotecaCompact.vue";

new Vue({
  provide: {
    ...container.getAll(),
  },
  created() {
    // @ts-ignore
    this.$oruga.config.setOptions(OrugaConfig);
  },
  render(h: CreateElement) {
    return h(BibliotecaCompact);
  },
}).$mount("#biblioteca-compact");
